module.exports = __webpack_public_path__ + "static/intro-03e9ca9a3c3e3223240ce0fc3a8cc148.png";